<div class="search-container">
  <mat-card class="search-header">
    <div class="" #customerSection>
      <h3 class="page-title">
        <mat-icon class="title-icon">search</mat-icon>
        Customer Search
      </h3>
      <p class="page-subtitle">Search for customers and work orders using various criteria</p>
    </div>
    <div class="org-info">
      <mat-icon>supervised_user_circle</mat-icon>
      <span class="org-text">{{ userService?.orgDesc }}</span>
    </div>
  </mat-card>

  <div class="search-panel" [class.sidebar-collapsed]="isSidebarCollapsed">
    <mat-card class="search-sidebar" [class.collapsed]="isSidebarCollapsed">
      <div class="sidebar-header">
        <span *ngIf="!isSidebarCollapsed">Search By</span>
        <mat-icon class="collapse-btn" (click)="toggleSidebar()">
          {{ isSidebarCollapsed ? 'arrow_forward_ios' : 'arrow_back_ios' }}</mat-icon>
      </div>
      <nav class="search-nav">
        <button *ngFor="let tab of tabConfig; let i = index" class="nav-item" [class.active]="selectedIndex === i"
          (click)="changeTab(i)"
          [class.hidden]="(tab.label === 'By External Key' || tab.label === 'By PSD Job Number' || tab.label === 'By Contractor') && userService.dbBBCSId === ''"
          [matTooltip]="isSidebarCollapsed ? tab.label : ''">
          <mat-icon>{{ getTabIcon(tab.label) }}</mat-icon>
          <span *ngIf="!isSidebarCollapsed">{{ tab.label.replace('By ', '') }}</span>
        </button>
      </nav>

    </mat-card>

    <mat-card class="search-content">
      <div class="dynamic-header">
        <mat-icon class="header-icon">
          {{ getTabIcon(tabConfig[selectedIndex].label) }}
        </mat-icon>

        <h2 class="header-title">
          {{ tabConfig[selectedIndex].label }}
        </h2>
      </div>

      <ng-container [ngSwitch]="tabConfig[selectedIndex].label">

        <div *ngSwitchCase="'By Phone Number'">
          <mat-form-field appearance="outline" class="search-input">
            <mat-label>Phone Number (Numbers Only)</mat-label>
            <input [(ngModel)]="phoneNumber" (keypress)="allowOnlyNumbers($event)" matInput type="tel"
              (input)="onInputChange()" placeholder="Phone Number" (ngModelChange)="phoneNumber = $event.toUpperCase()">
          </mat-form-field>
        </div>

        <div *ngSwitchCase="'By Address'">

          <div class="address-input">
            <mat-form-field appearance="outline" class="search-input">
              <mat-label>First Name</mat-label>
              <input matInput [(ngModel)]="addressCriteria.FirstName" (input)="onInputChange()" placeholder="First Name"
                (ngModelChange)="addressCriteria.FirstName = $event.toUpperCase()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
              <mat-label>Last Name</mat-label>
              <input matInput [(ngModel)]="addressCriteria.LastName" (input)="onInputChange()" placeholder="Last Name"
                (ngModelChange)="addressCriteria.LastName = $event.toUpperCase()">
            </mat-form-field>
          </div>

          <div class="address-input">
            <mat-form-field appearance="outline" class="search-input">
              <mat-label>Full Name</mat-label>
              <input matInput [(ngModel)]="addressCriteria.FullName" (input)="onInputChange()" placeholder="Full Name"
                (ngModelChange)="addressCriteria.FullName = $event.toUpperCase()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
              <mat-label>Street Number</mat-label>
              <input matInput [(ngModel)]="addressCriteria.StreetAddressNumber" (input)="onInputChange()"
                placeholder="Street Number"
                (ngModelChange)="addressCriteria.StreetAddressNumber = $event.toUpperCase()">
            </mat-form-field>
          </div>

          <div class="address-input">
            <mat-form-field appearance="outline" class="search-input">
              <mat-label>Street Name</mat-label>
              <input matInput [(ngModel)]="addressCriteria.StreetAddressName" (input)="onInputChange()"
                placeholder="Street Name" (ngModelChange)="addressCriteria.StreetAddressName = $event.toUpperCase()">
            </mat-form-field>


            <mat-form-field appearance="outline" class="search-input">
              <mat-label>Apartment</mat-label>
              <input matInput [(ngModel)]="addressCriteria.Apartment" (input)="onInputChange()" placeholder="Apartment"
                (ngModelChange)="addressCriteria.Apartment = $event.toUpperCase()">
            </mat-form-field>
          </div>

          <div class="address-input">
            <mat-form-field appearance="outline" class="search-input">
              <mat-label>City</mat-label>
              <input matInput [(ngModel)]="addressCriteria.City" placeholder="City" (input)="onInputChange()"
                (ngModelChange)="addressCriteria.City = $event.toUpperCase()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
              <mat-label>State</mat-label>
              <input matInput [(ngModel)]="addressCriteria.State" (input)="onInputChange()" placeholder="State"
                (ngModelChange)="addressCriteria.State = $event.toUpperCase()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
              <mat-label>Zip Code</mat-label>
              <input matInput [(ngModel)]="addressCriteria.Zipcode" (input)="onInputChange()"
                (keypress)="allowOnlyNumbers($event)" placeholder="Zip Code"
                (ngModelChange)="addressCriteria.Zipcode = $event.toUpperCase()">
            </mat-form-field>
          </div>
        </div>

        <div *ngSwitchCase="'By Account'">
          <mat-form-field appearance="outline" class="search-input">
            <mat-label>Account Number to Search For</mat-label>
            <input [(ngModel)]="accountNumber" (input)="onInputChange()" matInput placeholder="Account Number"
              (ngModelChange)="accountNumber = $event.toUpperCase()">
          </mat-form-field>
        </div>

        <div *ngSwitchCase="'By Email'">
          <mat-form-field appearance="outline" class="search-input">
            <mat-label>Email</mat-label>
            <input [(ngModel)]="email" matInput type="email" (input)="onInputChange()" placeholder="Email"
              (ngModelChange)="email = $event.toUpperCase()">
          </mat-form-field>
        </div>

        <div *ngSwitchCase="'By Workorder'">
          <div class="address-input">
            <mat-form-field appearance="outline" class="search-input">
              <mat-label>Workorder Name</mat-label>
              <input [(ngModel)]="workorderName" matInput placeholder="Workorder" (input)="onInputChange()"
                (ngModelChange)="workorderName = $event.toUpperCase()">
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-input">
              <mat-label>Program</mat-label>
              <mat-select [(value)]="selectedProgram" (openedChange)="onDropdownOpen($event, 'program')"
                panelClass="status-dropdown-panel" (selectionChange)="onInputChange()">
                <mat-select-trigger>
                  {{ selectedProgram?.ProgramName || 'Select Program' }}
                </mat-select-trigger>
                <div class="status-search-container" (click)="$event.stopPropagation()">
                  <input #programSearchInput type="text" placeholder="Search Program..."
                    [(ngModel)]="searchInputs.program" autocomplete="off" class="inputSearch-status" />
                </div>
                <mat-option *ngFor="let program of getFilteredList('program')" [value]="program">
                  {{ program.ProgramName }}
                </mat-option>
                <mat-option *ngIf="getFilteredList('program')?.length === 0" disabled>No results found</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="address-input">
            <!-- =================== STATUS =================== -->
            <mat-form-field appearance="outline" class="search-input">
              <mat-label>Status</mat-label>
              <mat-select [(value)]="selectedStatus" (openedChange)="onDropdownOpen($event, 'status')"
                panelClass="status-dropdown-panel" (selectionChange)="onInputChange()">

                <mat-select-trigger>
                  {{ selectedStatus?.JobStatus || 'Select Status' }}
                </mat-select-trigger>

                <div class="status-search-container" (click)="$event.stopPropagation()">
                  <input #statusSearchInput type="text" placeholder="Search Status..." [(ngModel)]="searchInputs.status"
                    autocomplete="off" class="inputSearch-status" />
                </div>

                <mat-option *ngFor="let status of getFilteredList('status')" [value]="status">
                  {{ status.JobStatus }}
                </mat-option>

                <mat-option *ngIf="getFilteredList('status')?.length === 0" disabled>No results found</mat-option>
              </mat-select>
            </mat-form-field>
            <!-- =================== DATE PICKERS =================== -->
            <ng-container>
              <mat-form-field appearance="outline" class="search-input green-datepicker">
                <mat-label>Status - From Date</mat-label>
                <input matInput [matDatepicker]="fromPicker2" placeholder="Choose a date"
                  (ngModelChange)="onDateInputChange('start', $event)" (dateChange)="onInputChange()"
                  [(ngModel)]="startDate">

                <mat-datepicker-toggle matSuffix [for]="fromPicker2"></mat-datepicker-toggle>
                <mat-datepicker #fromPicker2></mat-datepicker>
              </mat-form-field>
              <mat-form-field appearance="outline" class="search-input green-datepicker">
                <mat-label>Status - To Date</mat-label>
                <input matInput [matDatepicker]="toPicker2" placeholder="Choose a date"
                  (ngModelChange)="onDateInputChange('end', $event)" (dateChange)="onInputChange()"
                  [(ngModel)]="endDate">
                <mat-datepicker-toggle matSuffix [for]="toPicker2"></mat-datepicker-toggle>
                <mat-datepicker #toPicker2></mat-datepicker>
              </mat-form-field>
            </ng-container>
          </div>
          <!-- =================== VALIDATION MESSAGES =================== -->
          <label *ngIf="noDataEntered" style="color: red">Please enter at least one field.</label>
          <label *ngIf="dateMismatch" style="color: red">To Date to be greater than From Date</label>
        </div>
        <div *ngSwitchCase="'By Serial Number'">
          <mat-form-field appearance="outline" class="search-input">
            <mat-label>Serial Number</mat-label>
            <input [(ngModel)]="serialno" matInput placeholder="Serial Number" (input)="onInputChange()"
              (ngModelChange)="serialno = $event.toUpperCase()">
          </mat-form-field>
        </div>

        <ng-container *ngIf="userService.dbBBCSId != ''">
          <div *ngSwitchCase="'By External Key'">
            <mat-form-field appearance="outline" class="search-input">
              <mat-label>External Key</mat-label>
              <input [(ngModel)]="externalkey" matInput placeholder="External Key" (input)="onInputChange()"
                (ngModelChange)="externalkey = $event.toUpperCase()">
            </mat-form-field>
          </div>
        </ng-container>

        <ng-container *ngIf="userService.dbBBCSId != ''">
          <div *ngSwitchCase="'By PSD Job Number'">
            <mat-form-field appearance="outline" class="search-input">
              <mat-label>PSD Job Number</mat-label>
              <input [(ngModel)]="jobno" matInput placeholder="PSD Job Number" (input)="onInputChange()"
                (ngModelChange)="jobno = $event.toUpperCase()">
            </mat-form-field>
          </div>
        </ng-container>

        <div *ngSwitchCase="'By PremiseId'">
          <mat-form-field appearance="outline" class="search-input">
            <mat-label>PremiseId</mat-label>
            <input [(ngModel)]="premiseId" matInput placeholder="PremiseId" (input)="onInputChange()"
              (ngModelChange)="premiseId = $event.toUpperCase()">
          </mat-form-field>
        </div>

        <ng-container *ngIf="userService.dbBBCSId != ''">
          <div *ngSwitchCase="'By Contractor'">
            <mat-form-field appearance="outline" class="search-input">
                <mat-label>Contractor</mat-label>
                <mat-select [(value)]="selectedContractor" (openedChange)="onContractorDropdownOpen($event, 'contractor')"
                  panelClass="status-dropdown-panel" (selectionChange)="onInputChange()">
                  <mat-select-trigger>
                    {{ selectedContractor?.OrganizationDesc || 'Select Contractor' }}
                  </mat-select-trigger>
                  <div class="status-search-container" (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()">
                    <input #contractorSearchInput type="text" placeholder="Search Contractor..."
                      [(ngModel)]="searchInputs.contractor" autocomplete="off" class="inputSearch-status" />
                  </div>
                  <mat-option *ngFor="let contractor of getFilteredList('contractor')" [value]="contractor">
                    {{ contractor.OrganizationDesc }}
                  </mat-option>
                  <mat-option *ngIf="getFilteredList('contractor')?.length === 0" disabled>No results found</mat-option>
                </mat-select>
              </mat-form-field>
          </div>
        </ng-container>        

        <div *ngSwitchCase="'By Check Number'">
          <mat-form-field appearance="outline" class="search-input">
            <mat-label>Check Number</mat-label>
            <input [(ngModel)]="checkNumber" matInput placeholder="Check Number" (input)="onInputChange()"
              (ngModelChange)="checkNumber = $event.toUpperCase()">
          </mat-form-field>
        </div>

        <div class="search-action-buttons">
          <button mat-raised-button color="primary" class="action-btn" (click)="doSearch()"
            [disabled]="!isAnySearchInputEntered">Search</button>
          <button mat-raised-button color="primary" class="action-btn" (click)="doClear()">Clear</button>
          <ng-container *ngIf="enableEnrollCustomer == 1 && !isContractor()">
            <button mat-raised-button class="action-btn new-customer" (click)="navigateToEnrollmentForm()">
              Add New Customer
            </button>
          </ng-container>

          <ng-container *ngIf="displayMasterSearch">
            <mat-checkbox class="red-checkbox" color="warn" [(ngModel)]="customerService.includeMaster">
              Include Master File in search
            </mat-checkbox>
          </ng-container>
        </div>
      </ng-container>
    </mat-card>
  </div>

  <div class="" #customerTableData>
    <mat-card class="result-card" *ngIf="displayResult">
      <div class="result-header">
        <div class="result-title-row">
          <mat-icon class="result-title-icon">list_alt</mat-icon>
          <span class="result-title-text">Customer Results</span>
          <span class="result-countlength"> {{ customers?.length }} </span>
        </div>
        <div class="result-subtitle-row">
          <mat-icon class="result-subtitle-icon">info</mat-icon>
          <span class="result-subtitle-text">Highlighted rows are from Master File</span>
        </div>
      </div>

      <mat-card-content class="result-table-wrapper">
        <div *ngIf="customers?.length < 1 && !searching" class="no-data-box">
          No Search Results
        </div>
        <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortCustData($event)"
          *ngIf="customers?.length > 0 && !searching" class="styled-table mat-elevation-z8">

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let cust" class="col-cell">
              {{ isContractor() ? maskName(cust.Name) : cust.Name | titlecase }}
            </td>
          </ng-container>
          <ng-container matColumnDef="account">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Account No</th>
            <td mat-cell *matCellDef="let cust" class="col-cell">
              {{ isContractor() ? maskValue(cust.AccountNumber) : cust.AccountNumber }}
            </td>
          </ng-container>
          <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Phone</th>
            <td mat-cell *matCellDef="let cust" class="col-cell">
              {{ isContractor() ? maskValue(cust.PrimaryPhone) : cust.PrimaryPhone }}
            </td>
          </ng-container>
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let cust" class="col-cell">
              {{ isContractor() ? maskValue(cust.Email) : cust.Email }}
            </td>
          </ng-container>
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Service Address</th>
            <td mat-cell *matCellDef="let cust" class="col-cell">
              {{ isContractor() ? maskValue(cust.ServiceStreetAddress1) : cust.ServiceStreetAddress1 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="zip">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Zip</th>
            <td mat-cell *matCellDef="let cust" class="col-cell">{{ cust.ServiceZipcode }}</td>
          </ng-container>
          <ng-container matColumnDef="providerName">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Provider</th>
            <td mat-cell *matCellDef="let cust" class="col-cell">{{ cust.ProviderName }}</td>
          </ng-container>
          <ng-container matColumnDef="premiseid">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Premise ID</th>
            <td mat-cell *matCellDef="let cust" class="col-cell">{{ cust.PremiseId }}</td>
          </ng-container>
          <ng-container matColumnDef="checknumber">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Check Number</th>
            <td mat-cell *matCellDef="let cust" class="col-cell">{{ cust.CheckNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="externalid">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>External ID</th>
            <td mat-cell *matCellDef="let cust" class="col-cell">
              <ng-container *ngIf="cust.OfficeId === 'DOM1'; else showExternalId">
                <button mat-raised-button color="primary" class="btn-past" (click)="openPastParticipationPopup(cust)">
                  Past Participation
                </button>
              </ng-container>
              <ng-template #showExternalId>{{ cust.ExternalId }}</ng-template>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row-data"
            [class.row-master]="row.FromMaster" (dblclick)="handleClick(row)">
          </tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10,25,50,100]" [pageSize]="25" showFirstLastButtons></mat-paginator>
      </mat-card-content>
    </mat-card>

    <mat-card class="result-card" *ngIf="displayWorkorder">
      <div class="result-header">
        <div class="result-title-row">
          <mat-icon class="result-title-icon">list_alt</mat-icon>
          <span class="result-title-text">Customer Results</span>
          <span class="result-countlength"> {{ workorders.length }} </span>
        </div>
        <div class="result-subtitle-row">
          <mat-icon class="result-subtitle-icon">info</mat-icon>
          <span class="result-subtitle-text">Highlighted rows are from Master File</span>
        </div>
      </div>
      <mat-card-content class="result-table-wrapper">
        <div *ngIf="workorders.length < 1 && !workorderSearching" class="no-data-box">
          No Search Results
        </div>
        <table mat-table [dataSource]="dataSource1" matSort (matSortChange)="sortWOData($event)"
          *ngIf="workorders.length > 0 && !workorderSearching" class="styled-table mat-elevation-z8">

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Name }}</td>
          </ng-container>
          <ng-container matColumnDef="program">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Program</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Program }}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Status }}</td>
          </ng-container>
          <ng-container matColumnDef="customer">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Customer</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Customer | titlecase }}</td>
          </ng-container>
          <ng-container matColumnDef="statusDate">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Date</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.StatusDate | date:'M/dd/yy' }}</td>
          </ng-container>
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Address</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Address | titlecase }}</td>
          </ng-container>
          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>City</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.City | titlecase }}</td>
          </ng-container>
          <ng-container matColumnDef="premiseid">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Premise</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.PremiseId }}</td>
          </ng-container>
          <ng-container matColumnDef="checknumber">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Check Number</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.CheckNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="externalid">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>External ID</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.ExternalId }}</td>
          </ng-container>
          <ng-container matColumnDef="externalKey">
            <th mat-header-cell *matHeaderCellDef class="col-header">External Key</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Externalkey }}</td>
          </ng-container>
          <ng-container matColumnDef="buttonSchedule">
            <th mat-header-cell *matHeaderCellDef class="col-header"></th>
            <td mat-cell *matCellDef="let w" class="col-cell action-buttons">
              <button mat-button matTooltip="Schedule" *ngIf="w.StatusNumber==190 && w.BucketScheduleEnabled==0"
                (click)="navigateToSchedule(w)">
                <mat-icon>watch</mat-icon>
              </button>
              <button mat-button matTooltip="Reschedule" *ngIf="w.StatusNumber==200" (click)="navigateToSchedule(w)">
                <mat-icon>update</mat-icon>
              </button>
              <button mat-button matTooltip="Bucket Scheduling"
                *ngIf="w.StatusNumber==190 && w.BucketScheduleEnabled==1" (click)="navigateToBucketSchedule(w)">
                <mat-icon>date_range</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns1;" class="row-data"
            [class.row-master]="row.FromMaster" (dblclick)="handleWorkorderClick(row)">
          </tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10,25,50,100]" [pageSize]="25" showFirstLastButtons></mat-paginator>
      </mat-card-content>
    </mat-card>

    <mat-card class="result-card" *ngIf="displaySerial">
      <div class="result-header">
        <div class="result-title-row">
          <mat-icon class="result-title-icon">list_alt</mat-icon>
          <span class="result-title-text">Customer Results</span>
          <span class="result-countlength"> {{ workorders.length }} </span>
        </div>
        <div class="result-subtitle-row">
          <mat-icon class="result-subtitle-icon">info</mat-icon>
          <span class="result-subtitle-text">Highlighted rows are from Master File</span>
        </div>
      </div>

      <mat-card-content class="result-table-wrapper">
        <div *ngIf="workorders.length < 1 && !workorderSearching" class="no-data-box">
          No Search Results
        </div>
        <table mat-table [dataSource]="dataSource1" matSort (matSortChange)="sortWOData($event)"
          *ngIf="workorders.length > 0 && !workorderSearching" class="styled-table mat-elevation-z8">

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Name</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Name }}</td>
          </ng-container>
          <ng-container matColumnDef="program">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Program</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Program }}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Status }}</td>
          </ng-container>
          <ng-container matColumnDef="customer">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Customer</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Customer }}</td>
          </ng-container>
          <ng-container matColumnDef="statusDate">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Date</th>
            <td mat-cell *matCellDef="let w" class="col-cell">
              {{ w.StatusDate | date:'M/dd/yy' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Address</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Address }}</td>
          </ng-container>
          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>City</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.City }}</td>
          </ng-container>
          <ng-container matColumnDef="serialno">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Serial No</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.SerialNo }}</td>
          </ng-container>
          <ng-container matColumnDef="premiseid">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Premise</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.PremiseId }}</td>
          </ng-container>
          <ng-container matColumnDef="checknumber">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>Check Number</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.CheckNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="externalid">
            <th mat-header-cell *matHeaderCellDef class="col-header" mat-sort-header>External ID</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.ExternalId }}</td>
          </ng-container>
          <ng-container matColumnDef="externalKey">
            <th mat-header-cell *matHeaderCellDef class="col-header">External Key</th>
            <td mat-cell *matCellDef="let w" class="col-cell">{{ w.Externalkey }}</td>
          </ng-container>
          <ng-container matColumnDef="buttonSchedule">
            <th mat-header-cell *matHeaderCellDef class="col-header"></th>
            <td mat-cell *matCellDef="let w" class="col-cell action-buttons">
              <button mat-button matTooltip="Schedule" *ngIf="w.StatusNumber == 190 && w.BucketScheduleEnabled == 0"
                (click)="navigateToSchedule(w)">
                <mat-icon>watch</mat-icon>
              </button>
              <button mat-button matTooltip="Reschedule" *ngIf="w.StatusNumber == 200" (click)="navigateToSchedule(w)">
                <mat-icon>update</mat-icon>
              </button>
              <button mat-button matTooltip="Bucket Scheduling"
                *ngIf="w.StatusNumber == 190 && w.BucketScheduleEnabled == 1" (click)="navigateToBucketSchedule(w)">
                <mat-icon>date_range</mat-icon>
              </button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns2" class="row-data"
            [class.row-master]="row.FromMaster" (dblclick)="handleWorkorderClick(row)">
          </tr>
        </table>
        <mat-paginator [pageSizeOptions]="[10,25,50,100]" [pageSize]="25" showFirstLastButtons>
        </mat-paginator>
      </mat-card-content>
    </mat-card>


   <mat-card class="result-card" *ngIf="displayCheckNumber">
 
  <div class="result-header">
    <div class="result-title-row">
      <mat-icon>list_alt</mat-icon>
      <span>Check Number Results</span>
      <span class="result-countlength">{{ customers?.length }}</span>
    </div>
  </div>
 
  <mat-card-content class="result-table-wrapper">
 
    <div *ngIf="customers?.length < 1 && !searching" class="no-data-box">
      No Search Results
    </div>
 
    <table
      mat-table
      [dataSource]="dataSource"
      *ngIf="customers?.length > 0 && !searching"
      class="styled-table mat-elevation-z8">
 
      <ng-container matColumnDef="check">
        <th mat-header-cell *matHeaderCellDef>Check Number</th>
        <td mat-cell *matCellDef="let row">
          {{ row.CheckNumber }}
        </td>
      </ng-container>
 
      <ng-container matColumnDef="customer">
        <th mat-header-cell *matHeaderCellDef>Customer Name</th>
        <td mat-cell *matCellDef="let row">
          {{ row.CustomerName }}
        </td>
      </ng-container>
 
      <ng-container matColumnDef="payee">
        <th mat-header-cell *matHeaderCellDef>Payee</th>
        <td mat-cell *matCellDef="let row">
          {{ row.PayeeName }}
        </td>
      </ng-container>
 
      <ng-container matColumnDef="workorderid">
        <th mat-header-cell *matHeaderCellDef>Workorder ID</th>
        <td mat-cell *matCellDef="let row">
          {{ row.WorkorderId }}
        </td>
      </ng-container>
 
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef>Description</th>
        <td mat-cell *matCellDef="let row">
          {{ row.Description }}
        </td>
      </ng-container>
 
      
      <tr mat-header-row *matHeaderRowDef="displayedColumns3"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns3" class="row-data"
            [class.row-master]="row.FromMaster" (dblclick)="handleClick(row)">
          </tr>
    </table>
 
    <mat-paginator
      [pageSizeOptions]="[10,25,50,100]"
      [pageSize]="25"
      showFirstLastButtons>
    </mat-paginator>
 
  </mat-card-content>
 
</mat-card>

  </div>
  <button mat-fab class="scroll-to-top" [class.show]="displayResult || displayWorkorder || displaySerial || displayCheckNumber"
    (click)="scrollToBuckets(customerSection)">
    <mat-icon>arrow_upward</mat-icon>
  </button>
</div>